export default "__VITE_ASSET__0a0bd91d__"